
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { DTypeForm } from '@grupo-constant/next-dtype/form';
import {
    EMBEDDED_COLLECTION_COLUMN_URI,
    EMBEDDED_ITEM_COLUMN_URI,
    TWOCOLUMNSTABLE_URI
} from '@grupo-constant/next-dtype/types';

@Component({
    selector: 'dtype-component-list',
    templateUrl: 'dtype-component-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeComponentListComponent {

    @Input() dtypeForm: DTypeForm;
    @Input() isUpdate = false;
    @Input() insertBefore: string;
    @Input() insertTemplate: TemplateRef<unknown>;

    embeddedItemUri = EMBEDDED_ITEM_COLUMN_URI;
    embeddedItemCollectionUri = EMBEDDED_COLLECTION_COLUMN_URI;
    twoColumnsTable = TWOCOLUMNSTABLE_URI;

    constructor() { }

}
